<p class="modal-title flex items-center gap-8">
  @if (inventoryOptions().typography_title_icon) {
  <svg-icon
    [src]="inventoryOptions().typography_title_icon"
    class="modal-title__icon flex items-center justify-center s-16"
  />
  }

  {{ inventoryOptions().typography_title ?? 'Deposit Items' }}
</p>
<div class="flex w-full filters items-center">
  @if (theme() === 'withdraw-store') {
  <div class="divider vertical h-24"></div>
  }
  <app-search-input
    [disabled]="skinsResource.isLoading() || !!skinsResource.error()"
    [(query)]="search"
  />
  @if (inventoryOptions().items_pure_filter_enabled && theme() === 'default') {
  <div class="divider vertical h-24"></div>
  <app-checkbox
    class="pure-items-checkbox"
    [(checked)]="pure"
    [disabled]="skinsResource.isLoading() || !!skinsResource.error()"
    ><p class="flex items-center gap-4">Pure items only</p></app-checkbox
  >
  }
  <!--  -->
  @if (inventoryOptions().items_pure_filter_enabled && theme() ===
  'withdraw-store') {

  <div class="pure-items--toggles">
    <button
      [class.selected]="!pure()"
      (click)="handleSelectWithdrawStore('skins')"
    >
      <svg-icon
        class="flex items-center justify-center s-16"
        [src]="
          inventoryOptions().tabs?.items_skins_icon ??
          'assets/icons/core/skins.svg'
        "
      />
      {{ inventoryOptions().tabs?.items_skins_text ?? "TF2 Skins" }}
    </button>
    <button
      [class.selected]="pure()"
      (click)="handleSelectWithdrawStore('pure')"
    >
      <svg-icon
        class="flex items-center justify-center s-16"
        [src]="
          inventoryOptions().tabs?.items_pure_icon ??
          'assets/icons/core/pure.svg'
        "
      />
      {{ inventoryOptions().tabs?.items_pure_text ?? "TF2 Pures" }}
    </button>
  </div>
  }
  <ng-content select="[inventory-top]"></ng-content>
  <!-- <app-select
    [title]="'Sort by'"
    [selected]="sort()"
    [options]="sortOptions"
    [disabled]="skinsResource.isLoading() || !!skinsResource.error()"
  /> -->
  <app-toggle
    [title]="'Sort by'"
    [value]="sort().label"
    (handleClick)="toggleSortOptions()"
    [arrowPosition]="sort().key === 'highest_price' ? 'top' : 'down'"
    [disabled]="skinsResource.isLoading() || !!skinsResource.error()"
  ></app-toggle>
</div>
<div class="divider horizontal w-full divider-between-header-and-content"></div>
@if (skinsResource.error()) {
<div
  style="text-align: center"
  class="flex flex-col gap-4 items-center justify-center w-full h-full skins"
>
  {{ skinsResource.error()?.message }}
  <button
    class="button button--style-primary h-32 padding-x-12 rounded-4"
    (click)="skinsResource.reload()"
  >
    Reload
  </button>
</div>
} @else if (skinsResource.isLoading() && !hasLoadedOnce()) {
<div class="skins skins--skeleton">
  @for (i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10,11,12,13,14, 15, 16, 17, 18, 19,
  20]; track $index) {
  <div
    class="h-full w-full skeleton-animation rounded-4"
    style="background: var(--gray-24); height: 100%"
  ></div>
  }
</div>
} @else {
<app-skins-list
  class="skins"
  [skins]="skins()"
  [(selectedSkins)]="selectedSkins"
  [unavailableSkinsAssetIds]="unavailableSkinsAssetIds()"
  [selectable]="true"
  [config]="inventorySkinsListConfig()"
  [balanceType]="balanceType() ?? (pure() ? 'pure' : 'skins')"
/>
@if (isProcessing()) {
<div
  animate.enter="animate-fade-in"
  class="w-full flex flex-col gap-4 items-center absolute-center processing"
></div>
<app-loading-icon
  class="absolute-center"
  [color]="'var(--yellow)'"
  [size]="'48px'"
  animate.enter="animate-fade-in"
/>
} @if ((skinsResource.value()?.length ?? 0) === 0 && !skinsResource.isLoading()) {
<div class="w-full flex flex-col gap-4 items-center absolute-center">
  <span class="typography-title">No items found, try reload </span>
  <button
    class="button button--style-primary h-32 padding-x-12 rounded-4"
    (click)="refreshInventory()"
  >
    Reload
  </button>
</div>
} @if (skins().length === 0 && search() !== '' && !skinsResource.isLoading()) {
<div class="w-full flex flex-col gap-4 items-center absolute-center">
  <span class="typography-title">No items found, try clear search</span>
  <button
    class="button button--style-primary h-32 padding-x-12 rounded-4"
    (click)="search.set('')"
  >
    Clear search
  </button>
</div>
} } @if (!inventoryFooterUISettings()?.disabled){
<div class="summary" [class.tf2hunt--skins-shadow]="false">
  @if ((theme() === 'default') && !skinsResource.isLoading() &&
  !skinsResource.error()) {
  <div animate.enter="animate-fade-in" class="inventory--value">
    <span class="inventory--value__title">Inventory value</span>
    <app-cost
      [cost]="inventoryPrice()"
      [balanceType]="balanceType() ?? (pure() ? 'pure' : 'skins')"
    />
    <span class="divider vertical h-full"></span>
    <button
      class="inventory--value__refresh"
      [disabled]="isProcessing()"
      (click)="refreshInventory()"
    >
      <svg-icon
        class="flex items-center justify-center"
        [svgStyle]="{ width: '18px', height: '18px' }"
        src="assets/icons/ui/refresh.svg"
        [class.icon-rotating]="isShowRefreshAnimation()"
      ></svg-icon>
    </button>
  </div>
  }
  <div class="summary--container">
    <div class="summary--content">
      <svg-icon
        class="bg"
        src="assets/images/ui-effects/background-vector.svg"
      />
      <div class="summary--selected-items">
        <app-cost
          [cost]="selectedSkinsPrice()"
          [balanceType]="balanceType() ?? (pure() ? 'pure' : 'skins')"
        />
        <span class="summary--selected-items__text typography-info"
          >{{ selectedSkins().length }} items selected</span
        >
      </div>
      <div class="divider vertical h-full"></div>
      @if (requirementsOptions() && !inventoryFooterUISettings()?.hide_requirements_info) {
      <div class="summary--deposit-details">
        <p>{{ requirementsOptions()?.requirements_title }}</p>
        <p class="summary--deposit-details__text typography-info">
          Min {{ requirementsOptions()?.requirements_accent_word }}:
          <span>
            {{
              requirementsOptions()?.requirements_options_min_value
                | currency : "USD" : "symbol" : "1.2-2"
            }} </span
          >; Max. {{ requirementsOptions()?.requirements_accent_word }} value:
          <span>
            {{
              requirementsOptions()?.requirements_options_max_value
                | currency : "USD" : "symbol" : "1.2-2"
            }} </span
          >; Min. items
          <span>
            {{ requirementsOptions()?.requirements_options_min_items }} </span
          >; Max items:
          <span>
            {{ requirementsOptions()?.requirements_options_max_items }}
          </span>
        </p>
      </div>
      <div class="divider vertical h-full"></div>
      } @if (theme() === 'withdraw-store' || inventoryFooterUISettings()?.show_refresh_button) {
      <button
        (click)="refreshInventory()"
        class="button button--style-primary padding-x-12 refresh-store--button"
        style="--button-height: 32px"
        [disabled]="
          skinsResource.isLoading() || !!skinsResource.error() || isProcessing()
        "
      >
        <svg-icon
          class="panel-icon flex items-center justify-center s-14"
          src="assets/icons/ui/refresh.svg"
          [class.icon-rotating]="isShowRefreshAnimation()"
        ></svg-icon>
        Refresh store
      </button>
      }

      <ng-content select="[inventory-bottom]"></ng-content>

      <button
        class="summary--action-button button button--style-yellow padding-x-12 loading"
        style="--button-height: 38px"
        (click)="action.emit({
          pure: pure(),
        })"
        [disabled]="isDisabledByRequirements() || isProcessing()"
        [class.is-processing]="isProcessing()"
      >
        {{ inventoryOptions().typography_action_button }}
      </button>
    </div>
  </div>
</div>
}
